/* eslint-disable sonarjs/max-switch-cases */
/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS, List } from 'immutable';
import LoyaltyConstants from '@tcp/core/src/components/features/CnC/LoyaltyBanner/LoyaltyConstants';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import BAGPAGE_CONSTANTS from '../BagPage.constants';
import { AVAILABILITY } from '../../../../../services/abstractors/CnC/CartItemTile';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';
import { getDateObject } from '../../../../../utils';

const initialState = fromJS({
  [DEFAULT_REDUCER_KEY]: null,
  orderDetails: {},
  localCartOrderItems: [],
  sfl: [],
  sflId: '',
  cartSflMerged: false,
  errors: false,
  loaded: false, // flag to check if cart data is fetched for the first time.
  bagLoading: true, // flag to check if cart data is loading (set/unset every time cart API invokes)
  nonCacheBagLoading: true,
  isRouting: false, // flag to check if cart page is routing to some other page.
  openItemDeleteConfirmationModalInfo: { showModal: false },
  currentItemId: null,
  moduleXContent: [],
  showConfirmationModal: false,
  isEditingItem: false,
  fromApplePayBillingPage: false,
  isCartSupressOnBagUpdate: false,
  calculatedEstimatedTax: 0,
  isTaxCalculated: false,
  couponCalculateTax: false,
  isNonCacheDataLoaded: 'false',
  isPlccShippingAddressUpdate: false,
  isTotalCalculated: { flag: false },
  defaultSocialProofBanner: false,
  removeCouponApiError: false,
  removeCouponApiSuccess: false,
  buttonLoader: false,
  plccLoginModalState: false,
  isQuickAddModalOpen: false,
  hasSflCallCompleted: false,
  adyenSessionData: null,
  adyenSetupData: null,
  isAddToBagCallMade: false,
  uiFlags: {
    isPayPalEnabled: false,
    openExpressAfterPayPopup: false,
    isPayPalWebViewEnable: false,
    isPayPalRenderDone: false,
    isPayPalLibraryRenderDone: false,
    lastItemUpdatedId: null,
    isTotalEstimated: true,
    isClosenessQualifier: false,
    recentlyRemovedItemsCount: 0,
    shouldRedirectBackTo: false,
    cartItemForRecommendations: null,
    largeProductImagesLoading: false,
    isCartItemsUpdating: {
      isItemDeleted: false,
      isItemUpdated: false,
    },
    cartItemSflError: null,
    isPickupStoreUpdating: false,
    isItemMovedToSflList: false,
    isSflItemDeleted: false,
    isBagItemDeleted: false,
    cartItemLargeImagesViewer: {
      opened: false,
      currentIndex: 0,
      itemId: '',
      productId: '',
    },
    isPayPalModalActionOOS: false,
    isApplePayModalActionOOS: false,
    isSflItemMovedToBag: false,
    addressIds: {
      previousId: '',
      currentId: '',
    },
    isGettingPaypalSettings: false,
    updateMiniBag: true,
    maxItemError: false,
    maxItemErrorDisplayed: false,
    couponMergeError: false,
    isCachedDataLoaded: false,
    isNonCachedDataLoaded: false,
    updateCartComplete: false,
    productListB4Delete: [],
    isZipError: null,
    setSubmitButtonState: false,
    showApplePayDefault: true,
  },
});

const resetState = initialState
  .set('bagLoading', false)
  .set('nonCacheBagLoading', false)
  .set('loaded', true)
  .set('orderDetails', fromJS({ orderItems: [] }));

function updateItem(state, itemId, status) {
  const indexValue = state
    .getIn(['orderDetails', 'orderItems'])
    .findIndex((item) => item.getIn(['itemInfo', 'itemId']) === itemId);
  if (indexValue >= 0) {
    return state.setIn(
      ['orderDetails', 'orderItems', indexValue, 'miscInfo', 'availability'],
      status
    );
  }
  return state;
}

function updateOrderDetailFlags(state, orderDetail) {
  let flagData = state;

  if ([false, true].includes(orderDetail.isShippingOrder)) {
    flagData = flagData.setIn(['orderDetails', 'isShippingOrder'], orderDetail.isShippingOrder);
  }
  if ([false, true].includes(orderDetail.isPaypalEnabled)) {
    flagData = flagData.setIn(['orderDetails', 'isPaypalEnabled'], orderDetail.isPaypalEnabled);
  }
  return flagData;
}
function updateAirMile(state, orderDetail) {
  let airMileData = state;
  if (orderDetail.airmiles) {
    airMileData = airMileData.setIn(['orderDetails', 'airmiles'], orderDetail.airmiles);
  }
  return airMileData;
}
// eslint-disable-next-line complexity
function updateOrderDetailSummary(state, orderDetail) {
  let summaryData = state;

  if (orderDetail.giftWrappingTotal >= 0) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'giftWrappingTotal'],
      orderDetail.giftWrappingTotal
    );
  }
  if (orderDetail.giftDiscountTotal !== 0) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'giftDiscountTotal'],
      orderDetail.giftDiscountTotal
    );
  }
  if (orderDetail.pointsToRedeem) {
    summaryData = summaryData.setIn(['orderDetails', 'pointsToRedeem'], orderDetail.pointsToRedeem);
  }
  if (orderDetail.savingsTotal >= 0) {
    summaryData = summaryData.setIn(['orderDetails', 'savingsTotal'], orderDetail.savingsTotal);
  }
  if (orderDetail.rewardsToBeEarned >= 0) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'rewardsToBeEarned'],
      orderDetail.rewardsToBeEarned
    );
  }
  if (orderDetail.c_earnPlaceCashCoupon >= 0) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'c_earnPlaceCashCoupon'],
      orderDetail.c_earnPlaceCashCoupon
    );
  }
  if (orderDetail.c_earnPlaceProximity >= 0) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'c_earnPlaceProximity'],
      orderDetail.c_earnPlaceProximity
    );
  }
  if (orderDetail.couponsTotal >= 0) {
    summaryData = summaryData.setIn(['orderDetails', 'couponsTotal'], orderDetail.couponsTotal);
  }
  if (orderDetail.totalOrderSavings >= 0) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'totalOrderSavings'],
      orderDetail.totalOrderSavings
    );
  }
  if (orderDetail.productTotal) {
    summaryData = summaryData.setIn(['orderDetails', 'productTotal'], orderDetail.productTotal);
  }
  if (orderDetail.shippingTotal >= 0) {
    summaryData = summaryData
      .setIn(['orderDetails', 'applePayShippingTotal'], orderDetail.applePayShippingTotal)
      .setIn(['orderDetails', 'shippingTotal'], orderDetail.shippingTotal);
  }
  if (orderDetail.cartTotalAfterPLCCDiscount >= 0) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'cartTotalAfterPLCCDiscount'],
      orderDetail.cartTotalAfterPLCCDiscount
    );
  }
  if (orderDetail.giftCardsTotal >= 0) {
    summaryData = summaryData.setIn(['orderDetails', 'giftCardsTotal'], orderDetail.giftCardsTotal);
  }
  if (orderDetail.totalTax >= 0) {
    summaryData = summaryData.setIn(['orderDetails', 'totalTax'], orderDetail.totalTax);
  }
  if (orderDetail.grandTotal >= 0) {
    summaryData = summaryData.setIn(['orderDetails', 'grandTotal'], orderDetail.grandTotal);
  }
  if (orderDetail.subTotal >= 0) {
    summaryData = summaryData.setIn(['orderDetails', 'subTotal'], orderDetail.subTotal);
  }

  if (orderDetail.isFreeShippingCouponApplied !== undefined) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'isFreeShippingCouponApplied'],
      orderDetail.isFreeShippingCouponApplied
    );
  }

  if (orderDetail.giftCardDetails) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'giftCardDetails'],
      fromJS(orderDetail.giftCardDetails)
    );
    summaryData = summaryData.setIn(
      ['orderDetails', 'appliedGiftCards'],
      fromJS(orderDetail.appliedGiftCards)
    );
    summaryData = summaryData.setIn(['orderDetails', 'giftCardsTotal'], orderDetail.giftCardsTotal);
  }
  if (orderDetail.taxIdentifierAttribute) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'taxIdentifierAttribute'],
      orderDetail.taxIdentifierAttribute
    );
  }
  if (orderDetail.shipments) {
    summaryData = summaryData.setIn(['orderDetails', 'shipments'], orderDetail.shipments);
  }
  if (orderDetail.stores) {
    summaryData = summaryData.setIn(['orderDetails', 'stores'], orderDetail.stores);
  }
  if (orderDetail.isBopisOrder) {
    summaryData = summaryData.setIn(['orderDetails', 'isBopisOrder'], orderDetail.isBopisOrder);
  }
  if (orderDetail.isECOM) {
    summaryData = summaryData.setIn(['orderDetails', 'isECOM'], orderDetail.isECOM);
  }
  if (orderDetail.isBossOrder) {
    summaryData = summaryData.setIn(['orderDetails', 'isBossOrder'], orderDetail.isBossOrder);
  }
  if (orderDetail.isPickupOrder) {
    summaryData = summaryData.setIn(['orderDetails', 'isPickupOrder'], orderDetail.isPickupOrder);
  }
  if (orderDetail.orderType) {
    summaryData = summaryData.setIn(['orderDetails', 'orderType'], orderDetail.orderType);
  }
  if (orderDetail.isShippingOrder) {
    summaryData = summaryData.setIn(
      ['orderDetails', 'isShippingOrder'],
      orderDetail.isShippingOrder
    );
  }
  return summaryData;
}
function updateCheckoutDetailPartial(orderDetailState, orderDetail) {
  let orderDetailNewState = orderDetailState;

  if (
    orderDetail.checkout &&
    orderDetail.checkout.shipping &&
    !orderDetail.checkout.shipping.noReduxUpdate
  ) {
    orderDetailNewState = orderDetailNewState.setIn(
      ['orderDetails', 'checkout', 'shipping'],
      fromJS(orderDetail.checkout.shipping)
    );
  }

  if (
    orderDetail.checkout &&
    orderDetail.checkout.billing &&
    !orderDetail.checkout.billing.noReduxUpdate
  ) {
    orderDetailNewState = orderDetailNewState.setIn(
      ['orderDetails', 'checkout', 'billing'],
      fromJS(orderDetail.checkout.billing)
    );
  }

  if (orderDetail?.checkout?.giftWrap) {
    orderDetailNewState = orderDetailNewState.setIn(
      ['orderDetails', 'checkout', 'giftWrap'],
      fromJS(orderDetail.checkout.giftWrap)
    );
  }

  return orderDetailNewState;
}

// eslint-disable-next-line complexity
function updateOrderDetailPartial(state, orderDetail) {
  let orderDetailState = updateOrderDetailSummary(state, orderDetail);
  orderDetailState = updateAirMile(orderDetailState, orderDetail);
  orderDetailState = updateOrderDetailFlags(orderDetailState, orderDetail);

  if (orderDetail.shipModeId) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'shipModeId'],
      orderDetail.shipModeId
    );
  }
  if (orderDetail.subTotalWithDiscounts >= 0) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'subTotalWithDiscounts'],
      orderDetail.subTotalWithDiscounts
    );
  }
  if (orderDetail.subTotalWithoutGiftCard >= 0) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'subTotalWithoutGiftCard'],
      orderDetail.subTotalWithoutGiftCard
    );
  }
  if (orderDetail.orderId) {
    orderDetailState = orderDetailState.setIn(['orderDetails', 'orderId'], orderDetail.orderId);
  }

  if (orderDetail.totalItems >= 0) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'totalItems'],
      orderDetail.totalItems
    );
  }
  if (orderDetail.orderItems) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'orderItems'],
      fromJS(orderDetail.orderItems)
    );
  }
  if (orderDetail.couponItems) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'couponItems'],
      orderDetail.couponItems
    );
  }
  if (orderDetail.c_couponMap) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'c_couponMap'],
      orderDetail.c_couponMap
    );
  }

  orderDetailState = updateCheckoutDetailPartial(orderDetailState, orderDetail);

  if (orderDetail.loyaltyPointsRequestPayload) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'loyaltyPointsRequestPayload'],
      orderDetail.loyaltyPointsRequestPayload
    );
  }

  if (orderDetail.orderAccessorieItems) {
    orderDetailState = orderDetailState.setIn(
      ['orderDetails', 'orderAccessorieItems'],
      orderDetail.orderAccessorieItems
    );
  }

  orderDetailState = orderDetailState.setIn(
    ['orderDetails', 'orderPriceAdjustments'],
    orderDetail.orderPriceAdjustments || []
  );

  orderDetailState = orderDetailState.set('loaded', true).set('bagLoading', false);
  return orderDetailState;
}

function updateOrderDetailComplete(state, orderDetail) {
  return state
    .set('loaded', true)
    .set('bagLoading', false)
    .set('orderDetails', fromJS(orderDetail));
}

function updateOrderDetailCompleteApplePay(state, orderDetail) {
  const productList = state.getIn(['orderDetails', 'orderItems']);

  let updatedOrderDetail = fromJS(orderDetail);
  if (productList) {
    updatedOrderDetail = updatedOrderDetail.set('orderItems', productList);
  }

  return state.set('loaded', true).set('bagLoading', false).set('orderDetails', updatedOrderDetail);
}

function updateItemData(state, payload) {
  const indexValue = state
    .getIn(['localCartOrderItems'])
    .findIndex((item) => item.getIn(['itemInfo', 'itemId']) === payload.itemId);
  if (indexValue >= 0) {
    return state
      .setIn(['localCartOrderItems', indexValue, 'itemInfo', 'quantity'], payload.quantity)
      .setIn(['localCartOrderItems', indexValue, 'productInfo', 'size'], payload.size)
      .setIn(['localCartOrderItems', indexValue, 'productInfo', 'color'], payload.skuInfo.color);
  }
  return state;
}

function updatePriceDropItem(state, payload) {
  let updatedState = state;

  payload.forEach((product) => {
    const indexValue = updatedState
      .getIn(['orderDetails', 'orderItems'])
      .findIndex((item) => item.getIn(['itemInfo', 'itemId']) === product?.itemId);

    if (indexValue >= 0) {
      updatedState = updatedState
        .setIn(
          ['orderDetails', 'orderItems', indexValue, 'itemInfo', 'lastViewedPrice'],
          product?.price
        )
        .setIn(
          ['orderDetails', 'orderItems', indexValue, 'itemInfo', 'lastViewedTime'],
          new Date().toISOString()
        );
    }
  });

  return updatedState;
}

function updatePriceDropItemInSfl(state, payload) {
  let updatedState = state;

  payload.forEach((product) => {
    const indexValue = updatedState
      .getIn(['sfl'])
      .findIndex((item) => item.getIn(['itemInfo', 'itemId']) === product?.itemId);
    if (indexValue >= 0) {
      updatedState = updatedState

        .setIn(['sfl', indexValue, 'itemInfo', 'lastViewedPrice'], product?.price)
        .setIn(['sfl', indexValue, 'itemInfo', 'lastViewedTime'], new Date().toISOString());
    }
  });
  return updatedState;
}

function removeMultipleItem(state, { orderItems = [] }) {
  const filteredCartItems = state
    .getIn(['orderDetails', 'orderItems'])
    .filter((item) => !orderItems.includes(item.getIn(['itemInfo', 'itemId'])));
  const productListB4Delete = state.getIn(['orderDetails', 'orderItems']);
  return state
    .set('productListB4Delete', productListB4Delete)
    .setIn(['orderDetails', 'orderItems'], filteredCartItems);
}

function addDeletedItemBack(state) {
  const productListB4Delete = state.get('productListB4Delete');
  return state.setIn(['orderDetails', 'orderItems'], productListB4Delete);
}

function setCartItemsUpdating(state, isCartItemUpdating) {
  return state.setIn(['uiFlags', 'isCartItemsUpdating'], isCartItemUpdating);
}

function setAfterPayPopup(state, afterPayOpen) {
  return state.setIn(['uiFlags', 'openExpressAfterPayPopup'], afterPayOpen);
}

function setIsBOSSCartAvailable(state, bossQty) {
  return state.setIn(['uiFlags', 'isBOSSCartAvailable'], bossQty);
}

function setConfirmationModalState(state, action) {
  let fromApplePayBillingPage = false;
  let isEditingItem = false;
  if (action.payload) {
    fromApplePayBillingPage = action.payload.fromApplePayBillingPage || false;
    isEditingItem = action.payload.isEditingItem || false;
  }
  return state
    .set('showConfirmationModal', true)
    .set('isEditingItem', isEditingItem)
    .set('fromApplePayBillingPage', fromApplePayBillingPage);
}

function updatePayPalStateValue(state, action) {
  const status = (action && action.orderDetails && action.orderDetails.isPaypalEnabled) || false;
  return state.setIn(['uiFlags', 'isPayPalEnabled'], status);
}

function setCartItemsSFL(state, isCartItemSFL) {
  return state.setIn(['uiFlags', 'isItemMovedToSflList'], isCartItemSFL);
}

function setSflItemDeleted(state, isCartItemSFL) {
  return state.setIn(['uiFlags', 'isSflItemDeleted'], isCartItemSFL);
}

function setBagItemDeleted(state, isCartItemSFL) {
  return state.setIn(['uiFlags', 'isBagItemDeleted'], isCartItemSFL);
}

function setCartItemsSflError(state, isCartItemSflError) {
  return state.setIn(['uiFlags', 'cartItemSflError'], isCartItemSflError);
}

function setZipCodeError(state, isZipError) {
  return state.setIn(['uiFlags', 'zipCodeError'], isZipError);
}

function setUpdateMiniBagFlag(state, payload) {
  if (!payload) {
    setLocalStorage({
      key: BAGPAGE_CONSTANTS.UPDATE_MINIBAG_TIMESTAMP,
      value: getDateObject().toString(),
    });
  }
  return state.setIn(['uiFlags', 'updateMiniBag'], payload);
}

// eslint-disable-next-line complexity
const returnBagPageReducerExtension = (state = initialState, action = {}) => {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (action.type) {
    case BAGPAGE_CONSTANTS.PAYPAL_BUTTON_HIDDEN:
      return state.set('paypalBtnHidden', action.payload);
    case BAGPAGE_CONSTANTS.FETCHING_CART_DATA:
      return state.set('bagLoading', true);
    case BAGPAGE_CONSTANTS.SET_BAG_LOADED_STATE:
      return state.set('loaded', true);
    case BAGPAGE_CONSTANTS.RESET_BAG_LOADED_STATE:
      return state.set('loaded', false);
    case BAGPAGE_CONSTANTS.SET_BAG_PAGE_ROUTING:
      return state.set('isRouting', action.payload);
    case BAGPAGE_CONSTANTS.UPDATE_PAYPAL_STATUS:
      return updatePayPalStateValue(state, action.payload);
    case BAGPAGE_CONSTANTS.IS_PAYPAL_BUTTON_RENDER_DONE:
      return state.setIn(['uiFlags', 'isPayPalRenderDone'], action.payload);
    case BAGPAGE_CONSTANTS.UPDATE_ADDRESS_IDS:
      return state
        .setIn(['uiFlags', 'addressIds', 'previousId'], action.payload.previousId)
        .setIn(['uiFlags', 'addressIds', 'currentId'], action.payload.currentId);
    case BAGPAGE_CONSTANTS.IS_PAYPAL_LIBRARY_RENDER_DONE:
      return state.setIn(['uiFlags', 'isPayPalLibraryRenderDone'], action.payload);
    case BAGPAGE_CONSTANTS.SET_BAG_PAGE_LOADING_STATUS:
      return state.setIn(['uiFlags', 'bagPageLoadingStatus'], action.payload);
    case BAGPAGE_CONSTANTS.UPDATE_MINIBAG_FLAG:
      return setUpdateMiniBagFlag(state, action.payload);
    case BAGPAGE_CONSTANTS.RESET_BAG_LOADING_STATE:
      return state.set('bagLoading', false);
    case BAGPAGE_CONSTANTS.UPDATE_AIRMILES_DATA:
      return state
        .setIn(['orderDetails', 'airmiles', 'promoId'], action.payload.deal)
        .setIn(['orderDetails', 'airmiles', 'accountNumber'], action.payload.account);
    case BAGPAGE_CONSTANTS.SET_PAYPAL_MODAL_ACTION_OOS:
      return state.setIn(['uiFlags', 'isPayPalModalActionOOS'], action.payload);
    case BAGPAGE_CONSTANTS.SET_APPLE_PAY_MODAL_ACTION_OOS:
      return state.setIn(['uiFlags', 'isApplePayModalActionOOS'], action.payload);
    case BAGPAGE_CONSTANTS.SET_COUPON_MERGE_ERROR:
      return state.setIn(['uiFlags', 'couponMergeError'], action.payload);
    case BAGPAGE_CONSTANTS.SET_MAX_ITEM_ERROR:
      return state.setIn(['uiFlags', 'maxItemError'], action.payload);
    case BAGPAGE_CONSTANTS.SET_OOS_ERROR:
      return state.setIn(['uiFlags', 'OOSError'], action.payload);
    case BAGPAGE_CONSTANTS.SET_VMP_ERROR:
      return state.setIn(['uiFlags', 'VMPError'], action.payload);
    case BAGPAGE_CONSTANTS.SET_MAX_ITEM_ERROR_DISPLAYED:
      return state.setIn(['uiFlags', 'maxItemErrorDisplayed'], action.payload);
    case BAGPAGE_CONSTANTS.SET_CACHED_DATA_LOADER:
      return state.setIn(['uiFlags', 'isCachedDataLoaded'], action.payload);
    case BAGPAGE_CONSTANTS.SET_NON_CACHED_DATA_LOADER:
      return state.setIn(['uiFlags', 'isNonCachedDataLoaded'], action.payload);
    case BAGPAGE_CONSTANTS.SET_BACKPACK_DELETED_ERROR:
      return state.setIn(['uiFlags', 'backPackDeletedError'], action.payload);
    case BAGPAGE_CONSTANTS.SET_SUBMIT_BUTTON_STATE:
      return state.setIn(['uiFlags', 'setSubmitButtonState'], action.payload);
    case BAGPAGE_CONSTANTS.UPDATE_CART_COUNT:
      return state.setIn(['orderDetails', 'totalItems'], action.payload.totalItems);
    case BAGPAGE_CONSTANTS.CART_SET_ORDER_ID:
      return state.setIn(['orderDetails', 'orderId'], action.payload.orderId);
    case BAGPAGE_CONSTANTS.REMOVE_DELETED_ITEM:
      return removeMultipleItem(state, action.payload);
    case BAGPAGE_CONSTANTS.ADD_DELETED_ITEM_ON_API_FAILURE:
      return addDeletedItemBack(state);
    case LoyaltyConstants.UPDATE_POINTS_IN_CART:
      return state
        .setIn(['orderDetails', 'estimatedRewards'], action.payload.estimatedRewards)
        .setIn(['orderDetails', 'isBrierleyWorking'], action.payload.isBrierleyWorking)
        .setIn(['orderDetails', 'orderItems'], action.payload.orderItems)
        .setIn(['orderDetails', 'orderAccessorieItems'], action.payload.orderAccessorieItems)
        .setIn(['orderDetails', 'pointsToNextReward'], action.payload.pointsToNextReward)
        .setIn(['orderDetails', 'earnedReward'], action.payload.earnedReward);
    case BAGPAGE_CONSTANTS.PAYPAL_SETTINGS_CALL_STATUS:
      return state.setIn(['uiFlags', 'isGettingPaypalSettings'], action.payload);
    case LoyaltyConstants.UPDATE_LOYALTY_POINTS:
      return state
        .setIn(['orderDetails', 'estimatedRewards'], action.payload.estimatedRewards)
        .setIn(['orderDetails', 'pointsToNextReward'], action.payload.pointsToNextReward)
        .setIn(['orderDetails', 'earnedReward'], action.payload.earnedReward)
        .setIn(['orderDetails', 'isBrierleyWorking'], action.payload.isBrierleyWorking);
    case BAGPAGE_CONSTANTS.SET_CART_SFL_MERGED:
      return state.set('cartSflMerged', action.payload);
    case BAGPAGE_CONSTANTS.UPDATE_CART_PRICE_DATA:
      return state
        .setIn(['orderDetails', 'totalItems'], action.payload.totalItems)
        .setIn(['orderDetails', 'grandTotal'], action.payload.grandTotal)
        .setIn(['orderDetails', 'giftCardsTotal'], action.payload.giftCardsTotal)
        .setIn(
          ['orderDetails', 'cartTotalAfterPLCCDiscount'],
          action.payload.cartTotalAfterPLCCDiscount
        )
        .setIn(['orderDetails', 'orderSubTotalDiscount'], action.payload.orderSubTotalDiscount);

    case BAGPAGE_CONSTANTS.UPDATE_ORDERTYPE_DATA:
      return state
        .setIn(['orderDetails', 'isBopisOrder'], action.payload.isBopisOrder)
        .setIn(['orderDetails', 'isBossOrder'], action.payload.isBossOrder)
        .setIn(['orderDetails', 'isECOM'], action.payload.isECOM)
        .setIn(['orderDetails', 'isPickupOrder'], action.payload.isPickupOrder);

    case BAGPAGE_CONSTANTS.SET_CART_SUPRESS_BAG_UPDATE:
      return state.set('isCartSupressOnBagUpdate', action.payload);
    case BAGPAGE_CONSTANTS.SET_ESTIMATED_TAX:
      return state
        .set('calculatedEstimatedTax', action.payload.tax)
        .set('isTaxCalculated', true)
        .set('isTotalCalculated', { flag: false })
        .set(DEFAULT_REDUCER_KEY, setCacheTTL(action.payload.estimatedTaxReduxTTLValue));
    case BAGPAGE_CONSTANTS.SET_ZIP_FOR_TAX:
      return state
        .set('zipForTaxEstimation', action.payload.zipcode)
        .set(DEFAULT_REDUCER_KEY, setCacheTTL(action.payload.estimatedTaxReduxTTLValue));
    case BAGPAGE_CONSTANTS.RESET_ZIP_FOR_TAX:
      return state
        .set('zipForTaxEstimation', null)
        .set('isTaxCalculated', false)
        .set(DEFAULT_REDUCER_KEY, null);
    case BAGPAGE_CONSTANTS.RESET_TAX:
      return state.set('isTaxCalculated', false).set(DEFAULT_REDUCER_KEY, null);
    case BAGPAGE_CONSTANTS.IS_TOTAL_CALCULATED:
      return state.set('isTotalCalculated', action.payload).set(DEFAULT_REDUCER_KEY, null);
    case BAGPAGE_CONSTANTS.ESTIMATED_TAX_FROM_DEFAULT_ADDRESS:
      return state.set('isEstimatedTaxFromDefaultShipping', action.payload);
    case BAGPAGE_CONSTANTS.NON_CACHE_DATA_LOADING:
      return state.set('isNonCacheDataLoaded', action.payload);
    case BAGPAGE_CONSTANTS.PLCC_SHIPPING_ADDRESS_UPDATE:
      return state.set('isPlccShippingAddressUpdate', action.payload);
    case BAGPAGE_CONSTANTS.IS_PLCC_IC_ADDRESS_MODAL_OPEN:
      return state.set('isPlccICAddressModalOpen', action.payload);
    case BAGPAGE_CONSTANTS.IS_PLCC_IC_PICKUP_MODAL_OPEN:
      return state.set('isPlccICPickupModalOpen', action.payload);

    case BAGPAGE_CONSTANTS.IS_FROM_ESTIMATED_TAX_FORM:
      return state.set('isFromEstimatedTaxForm', action.payload);
    case BAGPAGE_CONSTANTS.RESET_ESTIMATED_TAX_FROM_DEFAULT_ADDRESS:
      return state.set('isEstimatedTaxFromDefaultShipping', action.payload);
    case BAGPAGE_CONSTANTS.COUPON_CALCULATE_TAX:
      return state.set('couponCalculateTax', action.payload);
    case BAGPAGE_CONSTANTS.SET_ADYEN_SESSION_DATA:
      return state.set('adyenSessionData', action.payload);
    case BAGPAGE_CONSTANTS.SET_ADYEN_SETUP_DATA:
      return state.set('adyenSetupData', action.payload);

    default:
      // TODO: currently when initial state is hydrated on browser, List is getting converted to an JS Array
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

const returnBagPageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case BAGPAGE_CONSTANTS.OPEN_CHECKOUT_CONFIRMATION_MODAL:
      return setConfirmationModalState(state, action);
    case BAGPAGE_CONSTANTS.CLOSE_CHECKOUT_CONFIRMATION_MODAL:
      return state
        .set('showConfirmationModal', false)
        .set('isEditingItem', false)
        .set('fromApplePayBillingPage', false);
    case BAGPAGE_CONSTANTS.CART_ITEMS_SET_UPDATING:
      return setCartItemsUpdating(state, action.payload);
    case BAGPAGE_CONSTANTS.SET_AFTERPAY_OPEN:
      return setAfterPayPopup(state, action.payload);
    case BAGPAGE_CONSTANTS.SET_BOSS_CART_AVAILABLE:
      return setIsBOSSCartAvailable(state, action.payload);
    case BAGPAGE_CONSTANTS.CART_ITEMS_SET_SFL:
      return setCartItemsSFL(state, action.payload);
    case BAGPAGE_CONSTANTS.CART_ITEMS_SET_SFL_ERROR:
      return setCartItemsSflError(state, action.payload);
    case BAGPAGE_CONSTANTS.SET_TRANSLATED_SFL_DATA:
      return state.set('sfl', fromJS(action.payload));
    case BAGPAGE_CONSTANTS.SET_SFL_LIST_ID:
      return state.set('sflId', action.payload);
    case BAGPAGE_CONSTANTS.CLOSE_ITEM_DELETE_CONFIRMATION_MODAL:
      return state.set('openItemDeleteConfirmationModalInfo', { showModal: false });
    case BAGPAGE_CONSTANTS.OPEN_ITEM_DELETE_CONFIRMATION_MODAL:
      return state.set('openItemDeleteConfirmationModalInfo', {
        ...action.payload,
        showModal: true,
      });
    case BAGPAGE_CONSTANTS.SFL_ITEMS_MOVED_TO_BAG:
      return state.setIn(['uiFlags', 'isSflItemMovedToBag'], action.payload);
    case BAGPAGE_CONSTANTS.SET_PAYMENT_METHOD:
      return state.setIn(['orderDetails', 'checkout', 'billing', 'paymentMethod'], action.payload);
    case BAGPAGE_CONSTANTS.SET_ZIP_CODE_ERROR:
      return setZipCodeError(state, action.payload);
    default:
      return returnBagPageReducerExtension(state, action);
  }
};

// eslint-disable-next-line complexity
const BagPageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case BAGPAGE_CONSTANTS.GET_ORDER_DETAILS_COMPLETE:
      return updateOrderDetailComplete(state, action.payload);
    case BAGPAGE_CONSTANTS.GET_ORDER_DETAILS_COMPLETE_APPLE_PAY:
      return updateOrderDetailCompleteApplePay(state, action.payload);
    case BAGPAGE_CONSTANTS.GET_ORDER_DETAILS_PARTIAL:
      return updateOrderDetailPartial(state, action.payload);
    case BAGPAGE_CONSTANTS.SET_BAG_PAGE_ERRORS:
      return state.set('errors', fromJS(action.payload)).set('bagLoading', false);
    case BAGPAGE_CONSTANTS.SET_MODULEX_CONTENT:
      return state.set('moduleXContent', List(action.payload));
    case 'CART_SUMMARY_SET_ORDER_ID':
      return state.setIn(['orderDetails', 'orderId'], action.orderId);
    case BAGPAGE_CONSTANTS.SET_ITEM_OOS:
      return updateItem(state, action.payload, AVAILABILITY.SOLDOUT);
    case BAGPAGE_CONSTANTS.PAYPAL_WEBVIEW_ENABLE:
      return state.setIn(['uiFlags', 'isPayPalWebViewEnable'], action.payload);
    case BAGPAGE_CONSTANTS.SET_ITEM_UNAVAILABLE:
      return updateItem(state, action.payload, AVAILABILITY.UNAVAILABLE);
    case BAGPAGE_CONSTANTS.SET_ITEM_AVAILABLE:
      return updateItem(state, action.payload, AVAILABILITY.OK);
    case BAGPAGE_CONSTANTS.SET_ITEMS:
      return state.setIn(['orderDetails', 'orderItems'], action.payload);
    case BAGPAGE_CONSTANTS.SFL_ITEMS_SET_DELETED:
      return setSflItemDeleted(state, action.payload);
    case BAGPAGE_CONSTANTS.CLEAR_CACHED_CART_DATA_TTL:
      return state.set(DEFAULT_REDUCER_KEY, null);
    case BAGPAGE_CONSTANTS.SET_CACHED_CART_DATA_TTL:
      return state.set(DEFAULT_REDUCER_KEY, setCacheTTL(action.payload));
    case BAGPAGE_CONSTANTS.FETCHING_NON_CACHE_DATA:
      return state.set('nonCacheBagLoading', true);
    case BAGPAGE_CONSTANTS.RESET_NON_CACHE_BAG_LOADING_STATE:
      return state.set('nonCacheBagLoading', false);
    case BAGPAGE_CONSTANTS.GET_CACHED_CART_DATA_COMPLETED:
      return state.set('cartItemFetchComplete', true);
    case BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA_COMPLETED:
      return state.set('cartDetailFetchComplete', true);
    case BAGPAGE_CONSTANTS.BAG_ITEMS_SET_DELETED:
      return setBagItemDeleted(state, action.payload);
    case BAGPAGE_CONSTANTS.RESET_CART_DATA:
      return resetState;
    case BAGPAGE_CONSTANTS.UPDATE_CART_LOCAL_DATA:
      return state.set('localCartOrderItems', fromJS(action.payload));
    case BAGPAGE_CONSTANTS.UPDATE_CART_COMPLETE:
      return state.setIn(['uiFlags', 'updateCartComplete'], action.payload);
    case BAGPAGE_CONSTANTS.CART_ITEM_QUICK_UPDATE:
      return updateItemData(state, action.payload);
    case BAGPAGE_CONSTANTS.UPDATE_PRICE_DROP_VALUES:
      return updatePriceDropItem(state, action.payload);

    case BAGPAGE_CONSTANTS.UPDATE_PRICE_DROP_VALUES_IN_SFL:
      return updatePriceDropItemInSfl(state, action.payload);
    case BAGPAGE_CONSTANTS.BUTTON_SPINNER_LOADER:
      return state.set('buttonLoader', action.payload);
    case BAGPAGE_CONSTANTS.SHOW_APPLE_PAY_DEFAULT:
      return state.setIn(['uiFlags', 'showApplePayDefault'], action.payload);
    case BAGPAGE_CONSTANTS.SAVE_SHARE_CART_ERROR:
      return state.set('saveShareCartErr', action.payload);
    case BAGPAGE_CONSTANTS.FETCH_SHARE_CART_ERROR:
      return state.set('fetchShareCartErr', action.payload);
    case BAGPAGE_CONSTANTS.SET_DEFAULT_BANNER:
      return state.set('defaultSocialProofBanner', action.payload);
    case BAGPAGE_CONSTANTS.REMOVE_COUPON_FAIL:
      return state.set('removeCouponApiError', action.payload);
    case BAGPAGE_CONSTANTS.REMOVE_COUPON_SUCCESS:
      return state.set('removeCouponApiSuccess', action.payload);
    case BAGPAGE_CONSTANTS.TOGGLE_PLCC_LOGIN_MODAL:
      return state.set('plccLoginModalState', action.payload);
    case BAGPAGE_CONSTANTS.TOGGLE_QUICK_ADD_MODAL:
      return state.set('isQuickAddModalOpen', action.payload);
    case BAGPAGE_CONSTANTS.QUICK_ADD_MODAL_RECS_TYPE:
      return state.set('quickAddRecommendationsType', action.payload);
    case BAGPAGE_CONSTANTS.HAS_SFL_CALL_COMPLETED:
      return state.set('hasSflCallCompleted', action.payload);
    case BAGPAGE_CONSTANTS.SET_IS_MIXED_PAYMENT_WITH_PAYPAL:
      return state.set('isMixedPaymentWithPaypal', action.payload);
    case BAGPAGE_CONSTANTS.SET_ADD_TO_BAG_CALL_MADE:
      return state.set('isAddToBagCallMade', action.payload);

    default:
      return returnBagPageReducer(state, action);
  }
};

export default BagPageReducer;
